<template>
  <div class="pdv" v-if="venda">
    <template v-if="checkout.open">
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F1"
        :modifiers="['altKey']"
        @success="modalConfigurationToogle"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F2"
        :modifiers="['altKey']"
        @success="modalAtalhosToogle"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F2"
        @success="abrirVenda"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F3"
        @success="finalizeSale"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F4"
        @success="cancelaProduto(null)"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F6"
        @success="cancelarVenda"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F7"
        :modifiers="['altKey']"
        @success="modalCloseDescontoAcrescimoToogle('desconto')"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F8"
        :modifiers="['altKey']"
        @success="modalCloseDescontoAcrescimoItemToogle()"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F9"
        :modifiers="['altKey']"
        @success="modalCloseClienteToogle"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F10"
        :modifiers="['altKey']"
        @success="modalClosePagamentoToogle"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.F11"
        :modifiers="['altKey']"
        @success="modalCloseChangeUnitValueToogle"
      />
      <Keypress
        key-event="keyup"
        :prevent-default="true"
        :key-code="teclasEnum.INSERT"
        @success="modalCloseImportarPedidoToogle"
      />
    </template>

    <Navbar :label-message="resellerMessage" />

    <div class="position-relative text-center" style="top: 4rem">
      <b-container>
        <UnauthorizedFeaturePdv></UnauthorizedFeaturePdv>
      </b-container>
    </div>

    <div
      v-if="isHomologEnvironment() && !isGerencial()"
      class="position-relative text-center"
      style="top: 4rem"
    >
      <strong style="color: red">Ambiente de Homologação - Sem Valor Fiscal</strong>
    </div>

    <div v-if="isGerencial()" class="position-relative text-center" style="top: 4rem">
      <strong style="color: #4f4f4f">PDV - Pré-venda Gerencial</strong>
    </div>

    <CardBusca v-if="checkout.open" :onSearchClick="resetSelectedProduct">
      <template v-slot:quantidade>
        <h5>Quantidade</h5>
        <Money
          ref="quantidade"
          id="quantidade"
          :options="quantity"
          inputClass="input-quantidade"
          labelBold
          :disabled="quantityDisabled"
          :onEnter="adicionarProduto"
          v-model="quantidade"
        />
      </template>
      <template v-slot:formulario>
        <br />
        <Select
          v-if="isPlan360"
          placeholder="Informe o código, descrição, código de barras ou referência do produto"
          labelBusca="description"
          v-model="produto"
          ref="buscarProduto"
          :options="produtos"
          inputClass="busca-produto"
          :filterBy="productFilter"
          :change="changeProduto"
          :search="onSearch"
          :placeholder-in-field="placeholderSearch"
        >
          <template slot="options" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.description }}
              <br />
              R$
              {{
                valorReal(props.data.price, decimalPrice) +
                  ' | Qtd.: ' +
                  valorRealQuantidade(props.data.quantity, decimalQuantity)
              }}
            </div>
          </template>
          <template slot="selected">
            <div class="selected" style="text-transform: uppercase">
              <h3>{{ ultimoProduto.description }}</h3>
            </div>
          </template>
        </Select>
      </template>
      <template v-slot:valor>
        <h5 align="right">Valor</h5>
        <h3 align="right">R$ {{ valorReal(ultimoProduto.price, decimalPrice) }}</h3>
      </template>
    </CardBusca>

    <div :class="!checkout.open ? 'no-opening-checkout' : ''">
      <b-container>
        <b-row>
          <b-col col lg="7" class="pdv-itens">
            <CardItens
              :total="total"
              :items="venda.productOfTradeCollection"
              :valorPago="valorPago"
              :acrescimo="valorUS(venda.extraValue)"
              :desconto="valorUS(venda.discount)"
              :decimalPrice="decimalPrice"
              :decimalQuantity="decimalQuantity"
              :isGerencial="isGerencial()"
              :isHomolog="isHomologEnvironment()"
            />
          </b-col>

          <b-col col lg="5">
            <div
              :class="
                isGerencial() || isHomologEnvironment()
                  ? 'pdv-card-logo-gerencial-or-homolog'
                  : 'pdv-card-logo'
              "
            >
              <img v-if="client.image" :src="urlImage + client.image" />
              <div v-if="!client.image" :class="atalhos ? 'logo-pdv-atalhos' : 'logo-pdv'"></div>
              <b-button-group class="pdv-atalhos" v-if="checkout.open && atalhos">
                <b-button
                  @click="modalClosePagamentoToogle"
                  :class="modalClosePagamento ? 'btn-success' : ''"
                >
                  Pagamento (ALT+F10)
                </b-button>
                <b-button
                  @click="modalCloseClienteToogle"
                  :class="modalCloseCliente ? 'btn-success' : ''"
                >
                  Cliente (ALT+F9)
                </b-button>
                <b-button @click="modalCloseDescontoAcrescimoToogle('desconto')">
                  Desc. Acr. Tot. (ALT+F7)
                </b-button>
                <b-button @click="modalCloseDescontoAcrescimoItemToogle()">
                  Desc. Acr. Item (ALT+F8)
                </b-button>
              </b-button-group>
            </div>
            <b-card class="card-total-venda" v-if="total > 0">
              <b-row class="pdv-acoes">
                <b-col col style="padding: 0" @click="cancelarVenda">
                  <b-card
                    class="card-total-left"
                    style="
                    background-color: #fff;
                    font-size: 1.25rem !important;
                    color: #4f4f4f;
                    text-align: center;
                    cursor: pointer;
                  "
                  >
                    <span style="font-weight: 500">Cancelar (F6)</span>
                  </b-card>
                </b-col>
                <b-col
                  v-if="!!venda.productOfTradeCollection.length"
                  col
                  style="padding: 0"
                  @click="finalizeSale"
                >
                  <b-card class="card-total-right btn-finalizar-venda">
                    <span style="font-weight: 600">Finalizar (F3)</span>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <ShipayModal
      :close="modalShipayToogle"
      :open="modalShipay"
      :products="venda.productOfTradeCollection"
      :total="shipayPaymentTotal"
      :buyer="venda.buyer"
      :nfce-id="nota.id || null"
      :finalizeSale="finalizeSale"
      v-if="modalShipay"
    />

    <ZposModal
      :submitZpos="handleTransmit"
      :submitZposTransaction="handleCreateZposTransaction"
      :cancelZpos="handleCancelZpos"
      v-if="modalZpos"
    />

    <ZposTransactionModal
      :cancelTransaction="handleCancelZposTransaction"
      v-if="modalZposTransaction"
    />

    <Footer
      :configuracoes="modalConfigurationToogle"
      :checkout="checkout"
      :openCheckout="modalCheckoutToogle"
      :openAtalhos="modalAtalhosToogle"
      :openMenuFiscal="modalMenuFiscalToogle"
      :movimentationCheckout="modalCheckoutMovimentationToogle"
      :checkoutClose="modalCloseCheckoutToogle"
    />

    <TEFModal :submitTEF="handleTransmit" :submitTEFStone="handleCreateCobStone" v-if="modalTEF" />

    <TEFModalStone
      :consultTransaction="handleConsultCobStone"
      :cancelTransaction="handleCancelCobStone"
      v-if="modalTEFStone"
    />

    <ModalConfiguration
      :close="modalConfigurationToogle"
      :open="modalConfiguration"
      :onSave="saveModalConfiguration"
      :data="{
        indicator: this.venda.tipoIntermediador || null,
        intermediator: this.venda.intermediador || null,
        username: this.venda.usuarioIntermediador || null,
      }"
    />

    <ModalIntermediatorConfiguration
      :close="modalIntermediatorConfigurationToogle"
      :open="modalIntermediatorConfiguration"
      :message="currentErrorMessage"
      :onSave="finalizeSale"
      :model="venda.modelo"
      :serie="venda.serie"
      v-if="modalIntermediatorConfiguration"
    />

    <ModalOpenCheckout
      :close="modalCheckoutToogle"
      :open="modalCheckout"
      :openCheckout="openCheckout"
    />

    <ModalMovimentationCheckout
      :close="modalCheckoutMovimentationToogle"
      :open="modalCheckoutMovimentation"
      :setMovimentation="setMovimentation"
    />

    <ModalCloseCheckout
      :close="modalCloseCheckoutToogle"
      :open="modalCloseCheckout"
      :closeCheckout="closeCheckout"
    />

    <ModalAtalhos
      :close="modalAtalhosToogle"
      :open="modalCloseAtalhos"
      :hasChangePrice="
        this.client && this.client.fiscal && this.client.fiscal.emissor.allowsChangingUnitValue
      "
    />

    <ModalMenuFiscal :close="modalMenuFiscalToogle" :open="modalCloseMenuFiscal" />

    <ModalDescontoAcrescimo
      :close="modalCloseDescontoAcrescimoToogle"
      :open="modalCloseDescontoAcrescimo"
      :discount="venda.discount"
      :extraValue="venda.extraValue"
      :total="total"
      :impostos="totalNota"
      :totalDiscountPerItem="totalDiscountPerItem"
      :changeDescontoAcrescimo="changeDescontoAcrescimo"
      :sale="nota"
      :isGerencial="isGerencial()"
      ref="modalDescontoAcrescimo"
    />

    <ModalDiscountExtraValueItem
      :close="modalCloseDescontoAcrescimoItemToogle"
      :open="modalDiscountExtraValueItem"
      ref="modalDescontoAcrescimoItem"
    />

    <ModalCliente
      :close="modalCloseClienteToogle"
      :open="modalCloseCliente"
      :cliente="this.venda.buyer"
      :homeDelivery="this.venda.homeDelivery"
      :changeCliente="changeCliente"
      ref="modalCliente"
    />

    <ModalPagamentos
      :close="modalClosePagamentoToogle"
      :open="modalClosePagamento"
      :pagamentosVenda="this.venda.paymentModeCollection"
      :formasPagamento="pagamentos"
      :total="total"
      :valorPago="valorPago"
      :changePagamentoVenda="changePagamentos"
      ref="modalPagamento"
    />

    <ModalImportarPedido
      :close="modalCloseImportarPedidoToogle"
      :open="modalCloseImportarPedido"
      :pedidos="pedidos"
      :changePedido="changePedido"
      :search="searchPedidos"
      ref="modalImportarPedido"
    />

    <ModalConfigCheckout
      :close="modalConfigCheckoutToogle"
      :open="modalConfigCheckout"
      ref="modalConfigCheckout"
    />

    <ModalPreValidationNfe v-if="!loadingInit" />

    <ModalChangeUnitValue
      :close="modalCloseChangeUnitValueToogle"
      :open="modalCloseChangeUnitValue"
      :changePriceProduct="changePriceProduct"
      v-if="checkIfAllowsChangingUnitValue()"
    />

    <ModalDiscountLimit
      :discountBasedOn="discountBasedOn"
      @authorizedDiscount="authorizedDiscount"
      ref="modalDiscountLimit"
    />

    <ModalAdminPassword
      :parentComponentFunctionWhenSend="handleToFinalizeSaleWhenModalAdminPasswordIsCall"
      title="Limite de crédito excedido"
    />

    <ModalLoading
      :title="modalLoadingTitle"
      :subtitle="modalLoadingSubtitle"
      :information="modalLoadingInformation"
      :close="false"
      :escToClose="false"
      :open="modalLoading"
      :onClose="closeModalLoading"
    />
  </div>
</template>

<script>
import number from '@/core/Number';
import api from '@/configurations/service';
import { mapState, mapActions, mapGetters } from 'vuex';
import './Pdv.css';
import _ from 'lodash';
import printJS from 'print-js';
import { searchForProduct } from '@/reusable/filters';
import ModalAdminPassword from '@/modules/Person/modules/Client/components/modals/ModalAdminPassword';
import { ModalLoading } from '@/components/ModalLoading';
import ResellerMixin from '@/modules/Application/mixins/ResellerMixin';
import NumbersMixin from '@/modules/Application/mixins/NumbersMixin';
import DiscountMixin from '@/modules/Fiscal/mixins/DiscountMixin';
import PafMixin from '@/modules/Fiscal/mixins/PAFMixin';
import { ClientMixin } from '../../../../Application';
import InstallmentsMixin from '../../../../Application/mixins/InstallmentsMixin';
import AmbienteMixin from '../mixins/AmbienteMixin';
import PagamentosMixin from '../mixins/PagamentosMixin';
import SeriesMixin from '../mixins/SeriesMixin';
import FormatMixin from '../../../../Application/mixins/FormatMixin';
import { TECLAS, MODELO } from '../enums/Documento';
import { AMBIENTE } from '../../../enums/Ambientes';
import { PAYMENT_NAMES } from '../../../enums/paymentsThatRequireFinanceAgent';
import Navbar from '../components/Navbar';
import { ShipayModal } from '../components/Shipay';
import ModalDiscountLimit from '../../../components/ModalDiscountLimit';
import ModalConfiguration from '../components/ModalConfiguration';
import ModalIntermediatorConfiguration from '../components/ModalIntermediatorConfiguration';
import ModalCloseCheckout from '../components/ModalCloseCheckout';
import ModalOpenCheckout from '../components/ModalOpenCheckout';
import ModalMovimentationCheckout from '../components/ModalMovimentationCheckout';
import ModalDescontoAcrescimo from '../components/ModalDescontoAcrescimo';
import ModalDiscountExtraValueItem from '../components/ModalDiscountExtraValueItem';
import ModalCliente from '../components/ModalCliente';
import ModalPagamentos from '../components/ModalPagamentos';
import ModalAtalhos from '../components/ModalAtalhos';
import ModalMenuFiscal from '../components/ModalMenuFiscal';
import ModalImportarPedido from '../components/ModalImportarPedido';
import { CardItens, CardBusca } from '../components/Cards';
import Footer from '../components/Footer';
import PdvData from './PdvData';
import Money, { Select } from '../components/Form';
import PdvVendaProduto from './PdvVendaProduto';
import ModalConfigCheckout from '../components/ModalConfigCheckout';
import ModalPreValidationNfe from '../../Nfe/components/ModalPreValidationNfe';
import { connectSocket } from '../../../../../configurations/webSocket';
import ModalChangeUnitValue from '../components/ModalChangeUnitValue';
import TEFModal from '../components/ModalTEF';
import TEFModalStone from '../components/ModalTEFStone';
import ZposModal from '../components/ModalZpos';
import ZposTransactionModal from '../components/ModalZposTransaction';
import { DiscountModulesEnum, DiscountBasedOnEnum } from '../../../enums/DiscountEnum';
import { PRAZO } from '../../../../Inventory/modules/Payment/enums/PaymentModeTypeEnum';
import { orderTypeEnum } from '../../../../Inventory/modules/Shared/enums/orderTypeEnum';
import UnauthorizedFeaturePdv from '../components/UnauthorizedFeaturePdv';
import { NAME_ADMINISTRATION_STONE } from '../../../enums/PaymentMode';

export default {
  name: 'pdv',
  mixins: [
    ClientMixin,
    AmbienteMixin,
    PagamentosMixin,
    SeriesMixin,
    InstallmentsMixin,
    FormatMixin,
    ResellerMixin,
    DiscountMixin,
    PafMixin,
  ],
  components: {
    Navbar,
    CardBusca,
    CardItens,
    Footer,
    Money,
    Select,
    ShipayModal,
    ModalLoading,
    ModalDiscountLimit,
    ModalConfiguration,
    ModalIntermediatorConfiguration,
    ModalOpenCheckout,
    ModalAtalhos,
    ModalMenuFiscal,
    ModalMovimentationCheckout,
    ModalDescontoAcrescimo,
    ModalCliente,
    ModalPagamentos,
    ModalCloseCheckout,
    ModalImportarPedido,
    ModalConfigCheckout,
    ModalDiscountExtraValueItem,
    ModalPreValidationNfe,
    ModalAdminPassword,
    Keypress: () => import('vue-keypress'),
    ModalChangeUnitValue,
    TEFModal,
    TEFModalStone,
    ZposModal,
    ZposTransactionModal,
    UnauthorizedFeaturePdv,
  },
  data() {
    return {
      loadingInit: true,
      quantityDisabled: false,
      venda: {},
      pdvVendaProduto: null,
      percentageDiscountExceeded: null,
      authorizedDiscountValue: null,
      discountData: null,
      discountBasedOn: null,
      discountModule: DiscountModulesEnum.NFCE_PDV,
      urlImage: process.env.VUE_APP_S3_IMG_URL,
      urlImageDefault: process.env.VUE_APP_BASE_URL,
      shipayPaymentTotal: 0,
      modalCloseDescontoAcrescimo: false,
      modalCloseDescontoAcrescimoItem: false,
      modalCloseCliente: false,
      modalClosePagamento: false,
      descontoItem: null,
      totalDiscountPerItem: null,
      nota: {},
      shipayId: null,
      checkout: {},
      produto: null,
      cliente: {},
      ultimoProduto: {},
      produtos: [],
      clientes: [],
      pedidos: [],
      pagamento: null,
      showPaymentTransaction: false,
      pagamentoNoCartao: false,
      parcela: null,
      operacao: null,
      bandeira: null,
      bandeiras: null,
      bandeirasFilteredText: [],
      administradorasFilteredText: [],
      administradora: null,
      administradoras: [],
      numeroTransacao: null,
      quantidade: '1,00',
      valorPgto: 0,
      teclasEnum: TECLAS,
      quantity: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 2,
        masked: true,
      },
      modalShipay: false,
      modalTEF: false,
      modalTEFStone: false,
      modalZpos: false,
      modalZposTransaction: false,
      modalConfiguration: false,
      modalIntermediatorConfiguration: false,
      modalCheckout: false,
      modalCheckoutMovimentation: false,
      modalCloseCheckout: false,
      modalCloseAtalhos: false,
      modalCloseMenuFiscal: false,
      modalCloseImportarPedido: false,
      currentErrorMessage: null,
      atalhos: process.env.VUE_APP_ENV === 'DEVELOPMENT',
      clipp360SubscriptionId: 25,
      ordemClipp360SubscriptionId: 26,
      modalConfigCheckout: false,
      importedSaleText: '',
      importationNumbers: [],
      importationObs: [],
      defaultText: null,
      impostos: {},
      modalCloseChangeUnitValue: false,
      changePrice: 0,
      pedidosImportado: [],
      decimalPrice: 2,
      decimalQuantity: 2,
      consultTEF: null,
      cobTEF: {},
      modalLoading: false,
      modalLoadingTitle: 'Atualizando Tabelas do PAF',
      modalLoadingSubtitle: 'Atualização das tabelas do PAF em andamento',
      modalLoadingInformation: `Para atender os requisitos do PAF, precisamos atualizar algumas tabelas,
      esse procedimento pode demorar alguns minutos dependendo da quantidade de itens registrados,
      por favor aguarde.`,
      zposTransaction: {},
      zposCheckoutCollection: [],
    };
  },
  props: {
    confirm: {
      type: Function,
    },
  },
  async created() {
    this.setLoading(true);
  },
  mounted() {
    window.addEventListener('keydown', (e) => {
      const code = e.which || e.keyCode;
      const { teclasEnum } = this;
      if (code === teclasEnum.F5 || code === teclasEnum.F3 || code === teclasEnum.F6) {
        return e.preventDefault();
      }
      return true;
    });
    this.getDataInit();
    this.abrirVenda();
    this.getZposCheckoutCollection();
  },
  methods: {
    ...mapActions('fiscal', ['handleModalDiscountLimit']),
    ...mapActions('stone', [
      'setStoneConfigurated',
      'createCobStone',
      'consultCobStoneWebhook',
      'cancelCobStone',
      'consultCobStone',
      'printDocStone',
    ]),
    ...mapActions('zpos', [
      'setZposConfigurated',
      'setZposIntegratorCollection',
      'createZposTransaction',
      'getUsedZpos',
    ]),
    ...mapActions('emissor', ['setDiscountConfiguration']),
    ...mapActions('creditLimit', ['setCreditLimit']),
    ...mapActions('application', ['setLoading']),
    ...mapActions('pdv', [
      'getGeneratePrint',
      'printComprovanteGerencial',
      'postCheckout',
      'getSatTransmitter',
      'setDiscount',
      'handleModalDiscountExtraValueItem',
      'setDiscountItem',
      'setExtraValue',
      'getTotalNota',
      'fiscalValidateProduct',
      'changePriceWhenIssuing',
    ]),
    ...mapActions('client', ['cleanAdminPasswordIsValid', 'toggleModalAdminPassword']),
    ...mapActions('nfe', ['setPreValidationNfe', 'putXML']),
    ...mapActions('tef', ['getUsedTEF']),
    async getConfigEmissor() {
      if (window.localStorage.getItem('configurationEmissor')) {
        const configEmissor = await JSON.parse(window.localStorage.getItem('configurationEmissor'));
        this.decimalPrice = configEmissor.decimalPrice;
        this.decimalQuantity = configEmissor.decimalQuantity;
        this.quantity.precision = this.decimalQuantity;
      }
      if (!this.isEmpty(this.satTransmitter)) {
        this.decimalPrice = 2;
      }
      this.setQuantidade();
    },
    isGerencial() {
      const { gerencial } = this.$route.params;
      if (gerencial) return true;
      return false;
    },
    async getZposCheckoutCollection() {
      try {
        const { data } = await this.$http.post('fiscal.get-zpos-configuration-checkouts');
        if (!data) return;
        this.checkoutCollection = data;
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
      }
    },
    isStoneInUseByZpos() {
      if (!this.checkoutCollection) return false;
      return this.checkoutCollection.some(
        (e) => e.integrator.name === NAME_ADMINISTRATION_STONE.toUpperCase(),
      );
    },
    async getDataInit() {
      this.loadingInit = true;
      await this.setPreValidationNfe(this.isGerencial() ? MODELO.GERENCIAL : null);
      await this.getCheckout();
      await this.getSatTransmitter();
      await this.getProfileSat();
      await this.getClient();

      const isClientFromSC = this.getStateAcronym() === 'SC';

      if (isClientFromSC && !this.isGerencial()) {
        window.location.href = '/#/fiscal/nfce/';
      }

      await this.getAmbientes();
      await this.getCurrentEnvironment(this.isGerencial() ? MODELO.GERENCIAL : null);
      await this.getPagamentos();
      await this.getSeries(this.isGerencial() ? MODELO.GERENCIAL : undefined);
      await this.novaVenda();
      await this.getGeneratePrint();
      await this.getConfigEmissor();
      await this.setDiscountConfiguration();
      await this.setStoneConfigurated();
      // await this.updatePAFE2Registers();
      await this.setZposConfigurated();
      await this.setZposIntegratorCollection();
      this.loadingInit = false;
      this.closeInitModalsCaseEmptyNfeConfiguration();
      this.setLoading(false);
      this.getResellerMessage(this.client);
      this.discountData = this.getDiscountConfigByModule(this.discountModule);
      if (this.series.length === 0 && this.isGerencial()) {
        window.location.href = '/#/inventory/managerial/';
      }
    },
    async updatePAFE2Registers() {
      const isClientFromSC = this.getStateAcronym() === 'SC';

      if (this.isGerencial() || !isClientFromSC) return;

      this.openModalLoading();

      await this.updateE2Registers();

      this.closeModalLoading();
    },
    openModalLoading() {
      this.modalLoading = true;
    },
    closeModalLoading() {
      this.modalLoading = false;
    },
    setQuantidade() {
      if (this.decimalQuantity === 2) {
        this.quantidade = '1,00';
      }
      if (this.decimalQuantity === 3) {
        this.quantidade = '1,000';
      }
      if (this.decimalQuantity === 4) {
        this.quantidade = '1,0000';
      }
    },
    closeInitModalsCaseEmptyNfeConfiguration() {
      const { emissor, configuracao } = this.preValidationNfe;
      if (!emissor || !configuracao) {
        this.modalCheckout = false;
        this.modalConfigCheckout = false;
      }
    },
    closeCheckout() {
      this.$alert.success('Caixa fechado com sucesso!');
      this.checkout = {
        ...this.checkout,
        open: false,
      };
      this.modalCheckout = true;
    },
    async saveModalConfiguration({ indicator, intermediator, username }) {
      Object.assign(this.venda, {
        tipoIntermediador: indicator,
        intermediador: intermediator,
        usuarioIntermediador: username,
      });
      this.modalConfigurationToogle();
    },
    async handleGetBandeiras() {
      await this.getBandeiras();
      this.bandeirasFilteredText = this.bandeiras;
    },
    async handleGetAdministradoras() {
      await this.getAdministradoras();
      this.changeProduto();
      this.administradorasFilteredText = this.administradoras;
    },
    modalConfigurationToogle() {
      this.modalConfiguration = !this.modalConfiguration;
    },
    modalIntermediatorConfigurationToogle() {
      this.modalIntermediatorConfiguration = !this.modalIntermediatorConfiguration;
    },
    modalCheckoutToogle() {
      this.modalCheckout = !this.modalCheckout;
    },
    modalCloseCheckoutToogle() {
      this.modalCloseCheckout = !this.modalCloseCheckout;
    },
    modalAtalhosToogle() {
      this.modalCloseAtalhos = !this.modalCloseAtalhos;
    },
    modalMenuFiscalToogle() {
      this.modalCloseMenuFiscal = !this.modalCloseMenuFiscal;
    },
    modalCloseDescontoAcrescimoToogle(tipo = null) {
      this.modalCloseDescontoAcrescimo = !this.modalCloseDescontoAcrescimo;
      if (this.modalCloseDescontoAcrescimo) {
        this.getTotalNota(this.venda);
        if (tipo === 'desconto') {
          this.$nextTick(() => {
            if (this.$refs.modalDescontoAcrescimo) {
              this.$refs.modalDescontoAcrescimo.$refs.desconto.$el.querySelector('input').focus();
            }
          });
        }
        if (tipo === 'acrescimo') {
          this.$nextTick(() => {
            if (this.$refs.modalDescontoAcrescimo) {
              this.$refs.modalDescontoAcrescimo.$refs.acrescimo.$el.querySelector('input').focus();
            }
          });
        }
      }
    },
    modalCloseDescontoAcrescimoItemToogle() {
      this.handleModalDiscountExtraValueItem();
      if (this.modalDiscountExtraValueItem) {
        this.$nextTick(() => {
          if (this.$refs.modalCloseDescontoAcrescimoItem) {
            this.$refs.modalDescontoAcrescimoItem.$refs.desconto.$el.querySelector('input').focus();
          }
        });
      }
    },
    modalCloseClienteToogle() {
      this.modalCloseCliente = !this.modalCloseCliente;
      if (this.modalCloseCliente) {
        this.$nextTick(() => {
          if (this.$refs.modalCliente) {
            this.$refs.modalCliente.$refs.buscarCliente.$el.querySelector('input').focus();
          }
        });
      }
    },
    async modalClosePagamentoToogle() {
      this.modalClosePagamento = !this.modalClosePagamento;
      if (this.modalClosePagamento) {
        this.$nextTick(() => {
          if (this.$refs.modalPagamento) {
            this.$refs.modalPagamento.$refs.buscaPagamentos.$el.querySelector('input').focus();
          }
        });
      }
    },
    async modalCloseImportarPedidoToogle() {
      this.modalCloseImportarPedido = !this.modalCloseImportarPedido;
      if (this.modalCloseImportarPedido) {
        await this.getPedidos();
        this.$nextTick(() => {
          if (this.$refs.modalImportarPedido) {
            this.$refs.modalImportarPedido.$refs.buscaPedidos.$el.querySelector('input').focus();
          }
        });
      }
    },
    modalCheckoutMovimentationToogle() {
      this.modalCheckoutMovimentation = !this.modalCheckoutMovimentation;
    },
    setInternalExtraValue() {
      if (this.extraValue.percentExtraValue > 0) {
        const extraValue = number.round(this.total * this.extraValue.percentExtraValue, 2);
        this.setExtraValue({ valueExtraValue: extraValue });
      }
      this.venda.extraValue = this.extraValue.valueExtraValue;
    },
    setInternalValueDiscount() {
      if (this.discount.percentDiscount > 0) {
        const discount = number.round(this.total * this.discount.percentDiscount, 2);
        this.venda.discountIsPercentage = true;
        this.setDiscount({ valueDiscount: discount });
      }
      this.venda.discount = this.discount.valueDiscount;
    },
    changeDescontoAcrescimo() {
      this.resetProductsDiscounts();
      this.setInternalExtraValue();
      this.setInternalValueDiscount();
      this.prorateDiscountOnProducts();
      this.modalCloseDescontoAcrescimo = false;
    },
    prorateDiscountOnProducts() {
      const totalProductsPrice = this.getTotalProductsPrice();
      const currentDiscount = this.discount.valueDiscount;
      if (currentDiscount >= totalProductsPrice) {
        return this.$alert.warning('O desconto deve ser menor que o total dos produtos!');
      }
      this.venda.productOfTradeCollection = this.venda.productOfTradeCollection.map((product) => {
        const totalPrice = product.price * product.quantity;
        let { discount = 0 } = product;
        discount = (totalPrice * currentDiscount) / totalProductsPrice;
        return {
          ...product,
          discount: number.round(discount, 2),
          totalDiscount: number.round(discount, 2),
          discountIsPercentage: false,
          totalPrice: number.round(totalPrice - discount, 2),
        };
      });
      const totalProducts = this.venda.productOfTradeCollection.reduce(
        (total, e) => total + number.round(e.totalPrice, 2),
        0,
      );
      const lastProductPrice = this.venda.productOfTradeCollection[
        this.venda.productOfTradeCollection.length - 1
      ].totalPrice;
      const lastProductDiscount = this.venda.productOfTradeCollection[
        this.venda.productOfTradeCollection.length - 1
      ].discount;
      const restPrice =
        Number(totalProductsPrice) - Number(this.discount.valueDiscount) - Number(totalProducts);
      this.venda.productOfTradeCollection[
        this.venda.productOfTradeCollection.length - 1
      ].totalPrice = restPrice + Number(lastProductPrice);
      this.venda.productOfTradeCollection[this.venda.productOfTradeCollection.length - 1].discount =
        lastProductDiscount - Number(restPrice);
      this.venda.productOfTradeCollection[
        this.venda.productOfTradeCollection.length - 1
      ].totalDiscount = lastProductDiscount - Number(restPrice);
      const restDiscount =
        this.venda.productOfTradeCollection.reduce((acc, e) => acc + e.discount, 0) -
        this.discount.valueDiscount;
      this.venda.productOfTradeCollection[
        this.venda.productOfTradeCollection.length - 1
      ].discount -= number.round(restDiscount, 2);
      this.venda.productOfTradeCollection[
        this.venda.productOfTradeCollection.length - 1
      ].totalDiscount -= number.round(restDiscount, 2);
      return true;
    },
    resetProductsDiscounts() {
      this.venda.discountIsPercentage = false;
      this.venda.productOfTradeCollection = this.venda.productOfTradeCollection.map((product) => {
        const totalPrice = product.price * product.quantity;
        return {
          ...product,
          totalPrice,
          discount: 0,
          totalDiscount: 0,
          discountIsPercentage: false,
        };
      });
    },
    getTotalProductsPrice() {
      return this.venda.productOfTradeCollection.reduce(
        (previousValue, product) => previousValue + product.price * product.quantity,
        0,
      );
    },
    async openCheckout(selectedCaixa) {
      try {
        this.setLoading(true);
        const { data } = await this.$http.post('fiscal.post-open-checkout', {
          value: this.valorUS(selectedCaixa.value),
          configurationId: selectedCaixa.caixa.id,
          documentConfigurationId: selectedCaixa.documentConfiguration
            ? selectedCaixa.documentConfiguration.id
            : null,
          generatePrint: selectedCaixa.generatePrint,
        });
        this.checkout = data;
        this.$alert.success('Caixa aberto com sucesso!');
        this.modalCheckout = false;
        this.setLoading(false);
        if (data.printUrl != null) {
          this.imprimir(data.printUrl);
        }
      } catch (e) {
        this.setLoading(false);
      }
    },
    searchPedidos(value) {
      this.getPedidos(value);
    },
    async getPedidos(value = '') {
      try {
        const { data } = await this.$http.post('inventory.get-sale', {
          search: value,
          active: true,
          maxResults: 15,
          source: 'modal',
        });
        this.pedidos = data;
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
      }
    },
    async runManagerialRoutines() {
      try {
        await this.$http.post('fiscal.run-managerial-routines', {
          dados: this.venda,
          id: this.nota.id,
        });
      } catch (error) {
        this.$alert.error(error?.response?.data?.error_message);
        this.setLoading(false);
      }
    },
    async setMovimentation(value, type, generatePrint) {
      try {
        if (this.valorUS(value) === 0) {
          this.$alert.error('Valor não pode ser zero!');
          return;
        }
        if (type === null) {
          this.$alert.error('Selecione o tipo de movimentação!');
          return;
        }
        this.setLoading(true);
        const { data } = await this.$http.post('fiscal.post-checkout-movimentation', {
          value: this.valorUS(value),
          type,
          generatePrint,
        });
        this.$alert.success('Movimentação efetuada com sucesso!');
        this.modalCheckoutMovimentation = false;
        this.setLoading(false);
        if (data.printUrl) {
          this.imprimir(data.printUrl);
        }
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
        this.setLoading(false);
      }
    },
    async getCheckout() {
      try {
        const { data } = await this.$http.post('fiscal.get-checkout-current-user', {
          active: true,
        });
        this.checkout = data.checkout;
        const now = this.$moment().format('YYYY-MM-DD');
        if (
          !data.checkout.open &&
          this.isPlan360 &&
          window.location.origin === process.env.VUE_APP_BASE_URL_360
        ) {
          this.modalCheckout = true;
          await this.checkCheckout();
          await localStorage.setItem('checkoutOpeningVerify', now);
        }
      } catch {
        this.modalCheckout = true;
      }
    },
    modalShipayToogle() {
      this.modalShipay = !this.modalShipay;
    },
    modalTEFToogle() {
      this.modalTEF = !this.modalTEF;
    },
    modalTEFStoneToogle() {
      this.modalTEFStone = !this.modalTEFStone;
    },
    modalZposToogle() {
      this.modalZpos = !this.modalZpos;
    },
    modalZposTransactionToogle() {
      this.modalZposTransaction = !this.modalZposTransaction;
    },
    async handleConsultCobStone() {
      try {
        this.setLoading(true);
        const data = await this.consultCobStone(this.nota.id);
        this.setLoading(false);
        if (data.status) {
          clearInterval(this.consultTEF);
          this.consultTEF = null;
          this.cobTEF = {};
          const xml = await this.putXML(this.nota.id);
          if (xml.status) {
            this.transmitirVenda(this.nota.id);
          }

          this.modalTEFToogle();
          this.modalTEFStoneToogle();
        } else {
          this.$alert.error('Pagamento não realizado!');
        }
      } catch {
        this.setLoading(false);
        this.modalTEFToogle();
        this.modalTEFStoneToogle();
        clearInterval(this.consultTEF);
        this.consultTEF = null;
        this.cobTEF = {};
      }
    },
    async handleCancelCobStone() {
      if (!this.cobTEF.id) {
        return;
      }
      try {
        this.setLoading(true);
        const { data } = await this.cancelCobStone(this.cobTEF.id);
        if (data.status) {
          clearInterval(this.consultTEF);
          this.consultTEF = null;
          this.cobTEF = {};
          this.$alert.success('Operação realziada com sucesso!');
          this.transmitirVenda(this.nota.id);
        }
        this.setLoading(false);
        this.modalTEFToogle();
        this.modalTEFStoneToogle();
      } catch {
        this.setLoading(false);
        this.modalTEFToogle();
        this.modalTEFStoneToogle();
        clearInterval(this.consultTEF);
        this.consultTEF = null;
        this.cobTEF = {};
        this.novaVenda();
        this.abrirVenda();
      }
    },
    async handleCreateCobStone() {
      try {
        this.setLoading(true);
        const { data } = await this.createCobStone(this.nota.id);
        this.cobTEF = data;
        this.modalTEFStoneToogle();
        this.consultTEF = setInterval(() => {
          this.consultCobStoneWebhook(this.nota.id)
            .then((response) => {
              if (response.status) {
                clearInterval(this.consultTEF);
                this.putXML(this.nota.id).then((xml) => {
                  if (xml.status) {
                    this.transmitirVenda(this.nota.id);
                  }
                });
              }
            })
            .catch(() => {
              clearInterval(this.consultTEF);
              this.consultTEF = null;
            });
        }, 3000);
        this.setLoading(false);
      } catch {
        this.setLoading(false);
        clearInterval(this.consultTEF);
        this.consultTEF = null;
        this.cobTEF = {};
      }
    },
    async handleCreateZposTransaction() {
      try {
        this.modalZposTransactionToogle();
        await this.createZposTransaction(this.nota.id);

        const xml = await this.putXML(this.nota.id);
        if (xml.status) await this.transmitirVenda(this.nota.id);
      } catch (error) {
        this.modalZposTransactionToogle();
        this.$alert.error('Ocorreu um erro ao efetuar a transação com o POS');
      }
    },
    handleCancelZpos() {
      this.modalZposToogle();
    },
    handleCancelZposTransaction() {
      this.modalZposTransactionToogle();
    },
    modalConfigCheckoutToogle() {
      this.modalConfigCheckout = !this.modalConfigCheckout;
    },
    changeCliente(data) {
      this.venda.homeDelivery = data.homeDelivery;

      if (data.client) {
        this.venda.buyer = data.client;
        this.modalCloseClienteToogle();
      }
    },
    changePagamentos(selectedPagamento = []) {
      const serializedPayment = this.serializePayment(selectedPagamento);
      this.venda.paymentModeCollection = serializedPayment;
      this.modalClosePagamentoToogle();
    },
    serializePayment(paymentModeCollection) {
      return paymentModeCollection.map((item) => {
        const paymentMode = item;
        if (
          paymentMode.cardAdministrator &&
          typeof paymentMode.cardAdministrator.financeAgent !== 'number'
        ) {
          paymentMode.cardAdministrator.financeAgent = paymentMode.cardAdministrator.financeAgent
            ? paymentMode.cardAdministrator.financeAgent.id
            : null;
        }
        return paymentMode;
      });
    },
    async changePedido(pedido = null) {
      if (pedido === null) {
        return false;
      }
      await this.setLoading(true);
      const { data } = await this.$http.post('inventory.get-detailed-sale', {
        id: pedido.id,
      });
      const wrongFiscalProduct = await this.fiscalValidateProduct(data.productOfTradeCollection);
      if (wrongFiscalProduct && wrongFiscalProduct.length) {
        wrongFiscalProduct.forEach((message) => {
          if (message) {
            this.$alert.warning(message);
          }
        });
      }
      this.pedidosImportado.push(data);
      if (this.venda.buyer.uuid) {
        if (this.venda.buyer.uuid !== data.buyer.uuid) {
          this.setLoading(false);
          this.$alert.error('Não é permitido importar pedido de cliente diferente da venda!');
          return false;
        }
      }
      if (data.warnings.productsOutOfStock) {
        data.warnings.productsOutOfStock.forEach((item) => {
          this.$alert.warning(`Produto ${item.description} sem estoque`);
        });
      }
      const serializedProductOfTradeCollection = data.productOfTradeCollection.map((item) => {
        if (item.discountIsPercentage) {
          const qtdPercent = 1 - item.discount / 100;
          const discountItem = item.price - item.price * qtdPercent;
          this.totalDiscountPerItem += discountItem;
          return {
            ...item,
            active: true,
            totalPrice: number.round(item.price * qtdPercent, this.decimalPrice),
            totalDiscount: discountItem,
          };
        }
        this.totalDiscountPerItem = this.valorReal(
          this.valorUS(item.discount) + this.valorUS(this.totalDiscountPerItem),
        );
        return {
          ...item,
          active: true,
          totalPrice: number.round(item.price * item.quantity - item.discount, this.decimalPrice),
          totalDiscount: item.discount,
        };
      });
      this.setExtraValue({ valueExtraValue: data.extraValue });
      this.setInternalExtraValue();
      this.venda.productOfTradeCollection = [
        ...this.venda.productOfTradeCollection,
        ...serializedProductOfTradeCollection,
      ];
      this.venda.freightPrice += data.freightPrice;
      this.venda.buyer = data.buyer;
      this.venda.seller = {
        id: data.id,
        sequence: data.sequence,
      };
      this.importationNumbers.push(` ${data.sequence}`);
      this.importedSaleText = `NFCe vinculada ao DAV n: ${data.sequence}`;
      if (this.importationNumbers.length > 1) {
        this.importedSaleText = `NFCe vinculada aos DAVs n: ${this.importationNumbers.sort()}`;
      }
      if (data.observation) {
        this.importationObs.push(`${data.observation}\n`);
      }
      await this.getObservation();
      await this.getTotalNota(this.venda);
      this.managePaymentForImportedSale(data);
      this.setLoading(false);
      this.$alert.success('Pedido importado!');
      this.modalCloseImportarPedidoToogle();
      this.venda.discount += data.discount;
      return true;
    },
    managePaymentForImportedSale(sale) {
      const salesImportedLength = this.pedidosImportado.length;
      const oneImportedSale = 1;
      const defaultPaymentExist = this.verifyIfPaymentIsDefault(sale.paymentMode);
      this.resetPaymentForSale();
      if (salesImportedLength === oneImportedSale && !defaultPaymentExist) {
        this.$alert.warning(
          `O parcelamento de seu pedido foi removido após a importação, informe-o novamente.
          Pagamento utilizado no pedido: ${sale.paymentMode.name}.`,
        );
        this.$refs.modalPagamento.changePagamentos(sale.paymentMode);
        return;
      }
      if (salesImportedLength > oneImportedSale) {
        this.$alert.warning(
          'O parcelamento de seu pedido foi removido após a importação, informe-o novamente.',
        );
      }
    },
    verifyIfPaymentIsDefault(paymentMode) {
      const defaultPayments = ['Dinheiro', 'Nenhum'];
      if (
        defaultPayments.includes(paymentMode.paymentType.name) &&
        paymentMode.isDefault === true
      ) {
        return true;
      }
      return false;
    },
    getDefaultPayment() {
      const defaultPaymentName = 'À vista';
      return this.pagamentos.find(
        (pagamento) => pagamento.isDefault === true && pagamento.name === defaultPaymentName,
      );
    },
    resetPaymentForSale() {
      const cashPayment = this.getDefaultPayment();
      this.$refs.modalPagamento.changePagamentos(cashPayment);
      this.$refs.modalPagamento.valorPgto = this.valorSubTotalReal(this.total);
      this.$refs.modalPagamento.listaPagamentos = [];
    },
    async getObservation() {
      const { data } = await this.$http.post('fiscal.get-inf-cpl', {
        dados: this.venda,
      });
      const promotionalMessage = data.promotionalMessage ? `${data.promotionalMessage}\n` : '';
      const icms = data.icms ? `${this.createLines(data.icms)}\n` : '';
      const diferido = data.icms_diferido ? `${this.createLines(data.icms_diferido)}\n` : '';
      const ibpt = this.createLines(data.ibpt);
      if (!this.defaultText) {
        this.venda.observation = `${promotionalMessage}${icms}${diferido}\n${ibpt}`;
      }
      if (this.importedSaleText) {
        this.venda.observation = `${promotionalMessage}${icms}${diferido}${this.importationObs.join(
          '\n',
        )}${this.importedSaleText}\n${ibpt}`;
      }
    },
    createLines(string) {
      if (!string) {
        return '';
      }
      return string.replace(/;/g, '\n');
    },
    applyDiscountItem(price) {
      const itemPrice = price;
      if (this.discountItem.valueDiscount == null) return itemPrice;
      const { percentDiscount, valueDiscount } = this.discountItem;
      const { percentExtraValue, valueExtraValue } = this.extraValueItem;
      let vDiscount = valueDiscount;
      let vExtraValue = valueExtraValue;
      if (percentDiscount > 0) {
        vDiscount = number.round((itemPrice * percentDiscount) / 100, 2);
        this.produto.discountIsPercentage = false;
      }
      if (percentExtraValue > 0) {
        vExtraValue = number.round((itemPrice * percentExtraValue) / 100, 2);
      }
      if (vDiscount > itemPrice) {
        throw this.$alert.warning(
          'Não é possível inserir um desconto maior que o valor total do item!',
        );
      }
      this.produto.discount = vDiscount;
      this.venda.discount += vDiscount;
      this.authorizedDiscountValue = this.venda.discount;
      return number.round(itemPrice - vDiscount + vExtraValue, 2);
    },
    async changeProduto(selectProduct, isBarCode = false) {
      if (!selectProduct) return false;

      const { data } = await api().post('/inventory.get-product', {
        id: selectProduct.id,
      });

      if (!data.length) return false;

      const [{ ...produto }] = data;

      this.produto = produto;
      this.produto.stockPrice = this.produto.price;
      this.ultimoProduto = this.produto;
      this.$nextTick(() => {
        if (this.$refs.quantidade) {
          this.$refs.quantidade.$el.querySelector('input').focus();
          if (isBarCode) {
            this.adicionarProduto();
            this.cleanAdminPasswordIsValid();
          }
        }
      });
      return true;
    },
    async checkCheckout() {
      await this.postCheckout({ status: true });
      const data = this.checkoutPosted;
      this.caixas = data;
      if (!this.caixas.length) {
        this.modalCheckout = false;
        this.modalConfigCheckout = true;
      }
    },
    isSatSale() {
      if (!Object.keys(this.satTransmitter).length) {
        this.decimalPrice = 2;
        return false;
      }
      return true;
    },
    async adicionarProduto() {
      this.quantityDisabled = true;
      this.shipayId = null;
      const currentIndex = this.venda.productOfTradeCollection.length;
      const quantidade = this.valorUS(this.quantidade);
      const originalPrice = this.produto ? this.produto.price : 0;
      const productPrice = this.changePrice || originalPrice;
      if (quantidade <= 0.0) {
        this.quantityDisabled = false;
        this.$alert.warning('Informe a quantidade do item!');
        this.$refs.quantidade.$el.querySelector('input').focus();
        return false;
      }
      if (productPrice === 0.0) {
        this.quantityDisabled = false;
        this.$alert.warning('Informe o valor do item!');
        return false;
      }
      let totalPrice = number.round(productPrice * quantidade, this.decimalPrice);
      totalPrice = this.applyDiscountItem(totalPrice);
      this.pdvVendaProduto = new PdvVendaProduto({
        totalPrice,
        price: productPrice,
        quantity: quantidade,
        product: this.produto,
        currentIndex: currentIndex + 1,
        discount: this.produto.discount,
        discountIsPercentage: this.produto.discountIsPercentage,
      });
      const messageFiscalValidate = await this.fiscalValidateProduct([this.pdvVendaProduto]);
      if (
        Array.isArray(messageFiscalValidate) &&
        messageFiscalValidate.length &&
        messageFiscalValidate[0]
      ) {
        this.$alert.warning(messageFiscalValidate[0]);
      }
      if (this.hasActiveDiscountConfiguration(this.discountData)) {
        const invalidDiscountWhenChangeProductPrice = this.invalidDiscountWhenChangeProductPrice();
        const percentageDiscount = this.getPercentageDiscountOnProduct(this.pdvVendaProduto);
        this.percentageDiscountExceeded = percentageDiscount > this.discountData.percentage;
        if (this.percentageDiscountExceeded || invalidDiscountWhenChangeProductPrice) {
          this.discountBasedOn = DiscountBasedOnEnum.ITEM;
          this.handleModalDiscountLimit();
          this.$nextTick(() => {
            if (this.$refs.modalDiscountLimit) {
              this.$refs.modalDiscountLimit.$refs.modalDiscountLimit.$el
                .querySelector('#discountLimitInput')
                .focus();
            }
          });
          return false;
        }
      }
      this.pushProdutoEntity();

      if (
        originalPrice !== productPrice &&
        !this.isGerencial() &&
        this.venda.tpNF?.toString() === '1'
      ) {
        await this.changePriceWhenIssuing({
          productId: this.produto.id,
          newPrice: productPrice,
        });
      }

      this.abrirVenda();
      setTimeout(async () => {
        await this.resetForNewItem();
      }, 100);
      this.totalDiscountPerItem = this.valorReal(
        this.venda.productOfTradeCollection.reduce(
          (total, item) => (item.discount ?? 0) + total,
          0,
        ),
      );
      this.$refs.buscarProduto.$el.querySelector('input').focus();
      return true;
    },
    invalidDiscountWhenChangeProductPrice() {
      if (!this.changePrice) return false;
      const discountPrice = this.produto.price - this.changePrice;
      const discountPercentage = (discountPrice * 100) / this.produto.price;
      return discountPercentage > this.discountData.percentage;
    },
    async authorizedItemDiscount() {
      this.authorizedDiscountValue = this.venda.discount;
      this.pushProdutoEntity();
      this.totalDiscountPerItem = this.valorReal(
        this.venda.productOfTradeCollection.reduce(
          (total, item) => (item.discount ?? 0) + total,
          0,
        ),
      );
      this.abrirVenda();
      setTimeout(async () => {
        await this.resetForNewItem();
      }, 100);
      return true;
    },
    authorizedSaleDiscount() {
      this.authorizedDiscountValue = this.venda.discount;
    },
    requestPasswordForDiscount() {
      return (
        this.percentageDiscountExceeded && this.authorizedDiscountValue !== this.venda.discount
      );
    },
    authorizedDiscount(discountBasedOn) {
      switch (discountBasedOn) {
        case DiscountBasedOnEnum.ITEM:
          return this.authorizedItemDiscount();
        case DiscountBasedOnEnum.DOC:
          return this.authorizedSaleDiscount();
        default:
          return false;
      }
    },
    pushProdutoEntity() {
      this.venda.productOfTradeCollection.push(this.pdvVendaProduto);
    },
    async resetForNewItem() {
      if (!this.produto) return;

      this.ultimoProduto = this.produto;
      this.produto = null;
      this.changePrice = 0;
      this.produtos = [];
      this.setQuantidade();
      this.setDiscountItem();
      this.quantityDisabled = false;
      await this.getTotalNota(this.venda);

      setTimeout(() => {
        const objDiv = document.getElementById('tableItensPdv');
        objDiv.scrollTop = objDiv.scrollHeight + 150;
      }, 100);
    },
    changePriceProduct(changePrice = 0) {
      if (changePrice !== 0) {
        this.changePrice = this.valorUS(changePrice);
      }
    },
    resetSelectedProduct() {
      this.produto = null;
      this.ultimoProduto = {};
    },
    onSearch(search, loading) {
      this.search(loading, search, this);
    },
    productFilter(option, __, query) {
      return searchForProduct(
        (option.description ?? '').toLocaleLowerCase(),
        query.toLocaleLowerCase(),
      );
    },
    search: _.debounce(async (loading, search, vm) => {
      if (search === '' || search === null) {
        return loading(false);
      }
      const $this = vm;
      let busca = search;
      if (busca.split('*').length > 1) {
        let quantidade = 1;
        [quantidade] = busca.split('*');
        [, busca] = busca.split('*');
        quantidade = `${quantidade}`.replace(',', '.');
        $this.quantidade = parseFloat(quantidade).toFixed($this.decimalQuantity);
      }
      if (busca.split('-').length > 1) {
        let indiceProduto;
        let funcaoDelete = null;
        [funcaoDelete] = busca.split('-');
        if (funcaoDelete === '') {
          [, indiceProduto] = busca.split('-');
          if (indiceProduto % 1 === 0 && indiceProduto !== '') {
            return $this.cancelaProduto(indiceProduto);
          }
        }
      }
      if (busca.trim() === '') {
        return false;
      }
      loading(true);
      $this.produtos = [];
      const response = await api().post('/inventory.search-products-for-documents', {
        search: busca,
        maxResults: 30,
        isPDV: true,
        orderType: orderTypeEnum.SALE,
      });
      const data = Array.isArray(response.data.data) ? response.data.data : [];
      if (data.length === 1) {
        if ($this.isBarCode(busca) && parseInt(busca, 10)) {
          $this.changeProduto(data[0], true);
        }
      }
      $this.produtos = data;
      loading(false);
      return true;
    }, 350),
    isBarCode(codigo) {
      if (codigo.length === 8) {
        return true;
      }
      if (codigo.length === 12) {
        return true;
      }
      if (codigo.length === 13) {
        return true;
      }
      if (codigo.length === 14) {
        return true;
      }
      return false;
    },
    hasPriceDiscountOrExtraValue() {
      const toNumber = (value) => {
        const result = value ? parseInt(value.toString().replace(/[^0-9]/, '') || 0, 10) : 0;
        return result;
      };
      return (
        toNumber(this.extraValue.valueExtraValue) > 0 ||
        toNumber(this.extraValueItem.valueExtraValue) > 0 ||
        toNumber(this.discount.valueDiscount) > 0 ||
        toNumber(this.discountItem.valueDiscount) > 0
      );
    },
    cancelaProduto(indiceProduto) {
      this.shipayId = null;
      let produto = indiceProduto - 1;
      if (indiceProduto === null) {
        if (this.venda.productOfTradeCollection.length === 0) {
          return false;
        }
        produto = this.venda.productOfTradeCollection.length - 1;
      }
      const item = this.venda.productOfTradeCollection[produto].product.description;
      return this.confirm({
        title: 'Cancelamento de item',
        message: `Deseja realmente cancelar o item: ${item}?`,
        open: true,
        onOk: async () => {
          try {
            this.venda.productOfTradeCollection[produto].active = false;
            this.venda.productOfTradeCollection[produto].totalPrice = 0;
            this.venda.productOfTradeCollection[produto].quantity = 0;
            this.$alert.success('Item cancelado com sucesso!');
            if (this.hasPriceDiscountOrExtraValue()) {
              this.$alert.warning(
                'Foram removidos os descontos / acréscimos da venda, por favor adicione novamente caso necessário!',
              );
              this.setDiscount({ valueDiscount: 0 });
              this.setExtraValue({ valueExtravalue: 0 });
              this.changeDescontoAcrescimo();
            }
            await this.getTotalNota(this.venda);
          } catch (e) {
            this.$alert.error(e?.response?.data?.error_message);
          }
        },
      });
    },
    acrescimoVenda() {
      this.modalCloseDescontoAcrescimo = !this.modalCloseDescontoAcrescimo;
      this.$nextTick(() => {
        if (this.$refs.acrescimo) {
          this.$refs.acrescimo.$el.querySelector('input').focus();
        }
      });
    },
    abrirVenda() {
      this.$nextTick(() => {
        if (this.$refs.buscarProduto) {
          this.$refs.buscarProduto.$el.querySelector('input').focus();
        }
      });
    },
    async criarNota(dados) {
      const { data } = await this.$http.post('/fiscal.post-nfe', { dados });
      return data;
    },
    async atualizarNota(id, dados) {
      const { data } = await this.$http.post('/fiscal.put-nfe', {
        id,
        dados,
      });
      return data;
    },
    atualizarPedidoById(nfeId) {
      if (!this.pedidosImportado || this.isGerencial()) return;

      this.pedidosImportado.forEach((pedido) => {
        const params = {
          id: pedido.id,
          nfeId,
          ...(pedido.paymentMode.range && {
            paymentMode: {
              id: pedido.paymentMode.id,
              range: pedido.paymentMode.range.map((range) => ({
                ...range,
              })),
            },
          }),
        };
        this.$http.post('/inventory.put-sale', params);
      });
    },
    imprimir(url) {
      const printDafe = window.open(url, '_blank');
      if (!printDafe || printDafe.closed) {
        return this.$alert.error(
          'Habilite o popup do navegador para visualizar os relatórios/comprovantes',
        );
      }
      printDafe.focus();
      return setTimeout(() => {
        printDafe.print();
      }, 1000);
    },
    async finalizarDocGerencial() {
      this.setLoading(true);
      await this.runManagerialRoutines();
      this.$alert.success('Operação realizada com sucesso!');
      if (this.nota && this.nota.id) {
        this.atualizarPedidoById(this.nota.id);
      }
      const comprovante = await this.printComprovanteGerencial({
        id: this.nota.id,
      });
      if (comprovante['base64-comprovante']) {
        printJS({
          printable: comprovante['base64-comprovante'],
          type: 'pdf',
          base64: true,
          onPrintDialogClose() {
            if (comprovante['base64-voucher']) {
              setTimeout(() => {
                printJS({ printable: comprovante['base64-voucher'], type: 'pdf', base64: true });
              }, 1000);
            }
          },
        });
      }
      if (comprovante['comprovante-url'] && !comprovante['base64-comprovante']) {
        this.imprimir(comprovante['comprovante-url'], '_blank');
      }
      if (comprovante['voucher-url'] && !comprovante['base64-voucher']) {
        this.imprimir(comprovante['voucher-url'], '_blank');
      }
      this.setLoading(false);
      return this.novaVenda();
    },
    async transmitirVenda(id) {
      try {
        const usedTef = await this.getUsedTEF({
          paymentModeCollection: this.venda.paymentModeCollection,
          stoneConfigurated: this.stoneConfigurated,
          isStoneInUseByZpos: this.isStoneInUseByZpos(),
        });

        if (this.isGerencial()) {
          if (usedTef) {
            this.printDocStone(id);
          }
          return this.finalizarDocGerencial();
        }
        const params = {
          id,
          sale_id: localStorage.getItem('sale_id'),
        };
        if (!this.isEmpty(this.satTransmitter)) {
          return this.transmitWithSat(params);
        }
        if (this.isCertA3) {
          await this.transmitWithA3(params);
        }
        if (this.isEmpty(this.satTransmitter) && !this.isCertA3) {
          this.setLoading(true);
          const { data: danfe } = await this.$http.post('/fiscal.transmit-nfe', params);
          if (danfe['danfe-url']) {
            if (usedTef) {
              this.printDocStone(id);
            }
            if (danfe['base64-danfe']) {
              printJS({
                printable: danfe['base64-danfe'],
                type: 'pdf',
                base64: true,
                onPrintDialogClose() {
                  if (danfe['voucher-url'] && danfe['base64-voucher']) {
                    setTimeout(() => {
                      printJS({ printable: danfe['base64-voucher'], type: 'pdf', base64: true });
                    }, 1000);
                  }
                },
              });
            } else {
              this.imprimir(danfe['danfe-url']);
            }
          }
          if (danfe['voucher-url']) {
            if (!danfe['base64-voucher']) {
              this.imprimir(danfe['voucher-url']);
            }
          }
          this.$alert.success('NFC-e criada com sucesso!');
          this.setLoading(false);
        }
        localStorage.removeItem('sale_id');
        this.abrirVenda();
        this.novaVenda();
        this.cleanAdminPasswordIsValid();
        this.setQuantidade();
        return this.nota.data;
      } catch {
        this.setLoading(false);
        this.novaVenda();
        this.abrirVenda();
        return false;
      }
    },
    async detalhesVenda(id) {
      try {
        await this.$http.post('/fiscal.get-detailed-nfe', {
          id,
          modelo: MODELO.NFCE,
        });
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
      }
    },
    async defaultPagamento() {
      const pagamentoAVista = await this.pagamentos.filter((item) => {
        const itemFilter = item.name ? item.name.toUpperCase() : ''.toUpperCase();
        const newText = String('À Vista').toUpperCase();
        return itemFilter.indexOf(newText) > -1;
      });
      const pagamento = await {
        ...pagamentoAVista[0],
        value: this.total,
      };
      pagamento.range = await this.calculateInstallments(
        pagamento,
        parseFloat(pagamento.value),
        pagamento.id,
      );
      this.venda.paymentModeCollection.push(pagamento);
    },
    hasClientForTermSale() {
      if (!this.venda.paymentModeCollection.length) return true;

      const hasPaymentWithTerm = this.venda.paymentModeCollection.find(
        (e) => e.paymentType.tPag === PRAZO,
      );

      if (!hasPaymentWithTerm) return true;

      return hasPaymentWithTerm && this.venda.buyer.id;
    },
    async finalizeSale(shipayId = null) {
      if (this.total === 0) {
        return false;
      }
      if (this.loading) {
        return false;
      }
      if (this.venda.paymentModeCollection.length === 0) {
        await this.defaultPagamento();
      }
      if (Number.isInteger(shipayId)) {
        this.shipayId = shipayId;
        this.modalShipay = false;
      }
      if (!this.hasClientForTermSale()) {
        return this.$alert.error('Para vendas à prazo é necessário informar um cliente.');
      }
      if (!this.validate1601FinanceAgent()) {
        return this.$alert.error(
          `O parâmetro para gerar o registro 1601 do SPED está ativado e o parcelamento está sem
          conta bancária ou a mesma está sem agente financeiro, verifique.`,
        );
      }
      try {
        const orderIds = this.pedidosImportado.map((pedido) => pedido.id);
        const dados = { shipayOrderId: this.shipayId, ...this.venda, orderIds };
        const troco = this.valorPago - this.total;
        dados.remainder = troco > 0 ? troco : 0;
        dados.price = this.total;
        await this.setLoading(true);
        let currentIndex = 0;
        dados.productOfTradeCollection = await this.venda.productOfTradeCollection
          .filter((product) => {
            const item = product;
            if (!item.quantity) {
              return null;
            }
            const itemFilter = item.active.toString();
            if (itemFilter.indexOf('true') > -1) {
              currentIndex++;
              item.currentIndex = currentIndex;
              return item;
            }
            return item;
          })
          .reverse();
        await this.getObservation();
        if (dados.buyer.identification) {
          dados.buyer.identification = dados.buyer.identification.replace(/[^A-Z0-9]+/g, '');
        }
        if (this.hasActiveDiscountConfiguration(this.discountData)) {
          const percentageDiscount = this.getPercentageDiscountOnPdvTrade(dados);
          this.percentageDiscountExceeded = percentageDiscount > this.discountData.percentage;
          if (this.requestPasswordForDiscount()) {
            this.discountBasedOn = DiscountBasedOnEnum.DOC;
            this.setLoading(false);
            this.handleModalDiscountLimit();
            this.$nextTick(() => {
              if (this.$refs.modalDiscountLimit) {
                this.$refs.modalDiscountLimit.$refs.modalDiscountLimit.$el
                  .querySelector('#discountLimitInput')
                  .focus();
              }
            });
            return false;
          }
        }
        const { creditLimitExceeded } = await this.setCreditLimit(dados);
        if (creditLimitExceeded && !this.adminPasswordIsValid) {
          this.setLoading(false);
          return this.toggleModalAdminPassword();
        }
        if (!this.nota || !this.nota.id) {
          this.nota = await this.criarNota(dados);
        }
        const usedTef = await this.getUsedTEF({
          paymentModeCollection: dados.paymentModeCollection,
          stoneConfigurated: this.stoneConfigurated,
          isStoneInUseByZpos: this.isStoneInUseByZpos(),
        });
        const usedZpos = await this.getUsedZpos({
          paymentModeCollection: dados.paymentModeCollection,
          zposConfigurated: this.zposConfigurated,
          zposIntegratorCollection: this.zposIntegratorCollection,
          isStoneInUseByZpos: this.isStoneInUseByZpos(),
        });
        if (this.isGerencial()) {
          if (usedTef) {
            this.setLoading(false);
            this.modalTEFToogle();
            return null;
          }
          if (usedZpos) {
            this.setLoading(false);
            this.modalZposToogle();
            return null;
          }
          return this.finalizarDocGerencial();
        }
        if (this.nota && this.nota.id) {
          this.atualizarPedidoById(this.nota.id);
        }
        if (this.checkOpenShipayModal()) {
          this.modalShipay = true;
          return true;
        }
        if (this.nota.errors) {
          this.setLoading(false);
          return this.$alert.error(this.nota.errors);
        }
        if (!this.nota.id) {
          this.setLoading(false);
          return this.$alert.error('Ocorreu um erro ao salvar!');
        }
        if (usedTef) {
          this.setLoading(false);
          this.modalTEFToogle();
          return true;
        }
        if (usedZpos) {
          this.setLoading(false);
          this.modalZposToogle();
          return true;
        }
        return this.handleTransmit();
      } catch (e) {
        this.setLoading(false);
        this.currentErrorMessage = e?.response?.data?.error_message ?? e.message;
        const toFind = 'indicativo do intermediador';
        if (this.currentErrorMessage.indexOf(toFind) !== -1) {
          return this.modalIntermediatorConfigurationToogle();
        }
        return this.$alert.error(this.currentErrorMessage);
      }
    },
    async handleTransmit() {
      if (this.modalTEF) {
        this.modalTEFToogle();
      }
      if (this.modalZpos) {
        this.modalZposToogle();
      }
      if (this.isGerencial()) {
        return this.finalizarDocGerencial();
      }
      return this.transmitirVenda(this.nota.id);
    },
    validate1601FinanceAgent() {
      const has1601ConfigurationEnabled = this.client.fiscal.emissor.enable1601Sped;
      return this.venda.paymentModeCollection.every((paymentMode) => {
        if (
          has1601ConfigurationEnabled &&
          !paymentMode.financeAgentId &&
          PAYMENT_NAMES.includes(paymentMode.paymentType.name)
        ) {
          return false;
        }
        return true;
      });
    },
    handleToFinalizeSaleWhenModalAdminPasswordIsCall() {
      this.finalizeSale();
    },
    cancelarVenda() {
      return this.confirm({
        title: 'Cancelamento da venda',
        message: 'Deseja realmente cancelar esta venda?',
        open: true,
        onOk: async () => {
          try {
            this.novaVenda();
            this.$alert.success('Venda cancelada com sucesso!');
          } catch (e) {
            this.$alert.error(e?.response?.data?.error_message);
          }
        },
      });
    },
    async novaVenda() {
      let dataVenda = {
        serie: this.series[0],
      };
      if (this.isGerencial()) {
        dataVenda = {
          modelo: MODELO.GERENCIAL,
        };
      }
      this.venda = new PdvData(dataVenda);
      this.percentageDiscountExceeded = null;
      this.authorizedDiscountValue = null;
      this.shipayId = null;
      this.modalCloseDescontoAcrescimo = false;
      this.modalCloseCliente = false;
      this.modalClosePagamento = false;
      this.produto = null;
      this.ultimoProduto = {};
      this.pagamento = {};
      this.cliente = {};
      this.nota = {};
      this.consultTEF = null;
      this.cobTEF = {};
      this.modalTEF = false;
      this.modalTEFStone = false;
      this.modalZpos = false;
      this.modalZposTransaction = false;
      this.setQuantidade();
      this.valorPgto = 0;
      this.importedSaleText = '';
      this.importationNumbers = [];
      this.importationObs = [];
      this.modalCloseChangeUnitValue = false;
      this.setDiscount({ valueDiscount: 0 });
      this.setDiscountItem();
      if (!this.isEmpty(this.satTransmitter) && !this.isGerencial()) {
        this.decimalPrice = 2;
        this.venda.modelo = parseInt(MODELO.SAT, 10);
      }
      this.modalCloseChangeUnitValue = false;
      this.pedidosImportado = [];
      await this.getTotalNota(this.venda);
      return true;
    },
    checkOpenShipayModal() {
      const shipay = this.venda.paymentModeCollection.filter((payment) => !!payment.isShipay);
      if (shipay.length > 0 && !this.shipayId) {
        this.shipayPaymentTotal = shipay.reduce((acc, cur) => acc + Number(cur.value), 0);
        return true;
      }
      return false;
    },
    getRangePayment(payment) {
      return payment.reduce((total, item) => total + item.value, 0);
    },
    async getProfileSat() {
      if (this.isEmpty(this.satTransmitter)) {
        this.decimalPrice = 2;
        return;
      }
      await this.novaVenda();
      const { data } = await this.$http.postWithCache('/application.get-profile');
      if (data.id) {
        await this.getStatusSAT(data.id);
      }
    },
    async getStatusSAT() {
      try {
        this.setLoading(true);
        const { data } = await this.$http.get('/fiscal.get-sat-transmitter');
        if (!data || this.isGerencial()) return;

        try {
          await this.$http.post('/TerminalZeta.ping', {
            checkoutId: this.checkout.configurationId,
            payload: {
              name: `Caixa ${this.checkout.identification}`,
            },
          });

          this.setLoading(false);
        } catch {
          this.$alert.error('Não foi possível se comunicar com o Terminal 360');
          setTimeout(() => this.$router.push('/#/'), 2000);
        }
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
        this.setLoading(false);
      }
    },
    isEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    async transmitWithSat(params) {
      this.setLoading(true);

      await api(2).post('/fiscal.cfe-sat-mfe-issue', params);

      const satSocket = connectSocket();
      const channel = 'zetaweb:cfe-sat-mfe:issue';

      satSocket.on(channel, (data) => {
        satSocket.off(channel);

        if (data.error) {
          this.$alert.error(
            typeof data.error === 'string'
              ? data.error
              : (data && data.mensagem) ||
                  (data && data.message) ||
                  (data && data.xMotivo) ||
                  'Erro ao conectar SAT',
          );
          this.setLoading(false);
          return;
        }

        if (data.data.danfeUrl) window.open(data.data.danfeUrl, '_blank');

        this.$alert.success('Documento transmitido com sucesso!');
        this.setLoading(false);
      });
    },
    async transmitWithA3(params) {
      this.setLoading(true);

      const a3Socket = connectSocket();
      const channel = 'zetaweb:nfe-nfce:transmit';

      a3Socket.on(channel, (data) => {
        a3Socket.off(channel);

        if (data.error) {
          this.$alert.error(data.error);
          this.setLoading(false);
          return;
        }

        if (data.data['danfe-url']) this.imprimir(data.data['danfe-url']);
        if (data.data['voucher-url']) this.imprimir(data.data['voucher-url']);

        this.$alert.success('Documento transmitido com sucesso!');
        this.setLoading(false);
      });

      try {
        await api(2).post('/fiscal.nfe-nfce-transmit', params);
      } catch (e) {
        this.setLoading(false);
        this.$alert.error(e?.response?.data?.error_message);
      }
    },
    modalCloseChangeUnitValueToogle() {
      this.modalCloseChangeUnitValue = !this.modalCloseChangeUnitValue;
    },
    checkIfAllowsChangingUnitValue() {
      if (this.produto) {
        return false;
      }
      return (
        this.client && this.client.fiscal && this.client.fiscal.emissor.allowsChangingUnitValue
      );
    },
    isHomologEnvironment() {
      return this.currentEnvironment === AMBIENTE.HOMOLOGACAO;
    },
  },
  computed: {
    ...mapGetters('emissor', ['getDiscountConfigByModule']),
    ...mapState('emissor', ['discountConfig']),
    ...mapState('stone', ['stoneConfigurated']),
    ...mapState('zpos', ['zposConfigurated', 'zposIntegratorCollection']),
    ...mapState('application', ['loading']),
    ...mapState('subscription', ['subscription', 'isPlan360']),
    ...mapState('client', ['adminPasswordIsValid']),
    ...mapState('nfe', ['preValidationNfe']),
    ...mapState('pdv', [
      'generatePrint',
      'satTransmitter',
      'checkoutPosted',
      'discount',
      'discountItem',
      'extraValueItem',
      'extraValue',
      'modalDiscountExtraValueItem',
      'totalNota',
    ]),
    placeholderSearch() {
      return this.venda.productOfTradeCollection?.length > 0
        ? 'Pressione F2 ou clique aqui para lançar um item'
        : 'Pressione F2 ou clique aqui para iniciar uma venda';
    },
    total() {
      // const produtos = this.venda.productOfTradeCollection || [];
      // let valor = produtos.reduce((total, item) => {
      //   const decimal = Math.max(this.decimalQuantity, this.decimalPrice);
      //   return total + NumbersMixin.methods.roundMultiply(item.quantity, item.price, decimal);
      // }, 0);
      let valor = this.totalNota.totalProd;
      if (
        this.client &&
        this.client.fiscal &&
        this.client.fiscal.emissor.icmsUnencumberedSubtractOnNfce
      ) {
        valor -= this.totalNota.ICMSdesoneracao;
      }
      valor -= this.venda.discount ?? 0;
      valor += this.venda.extraValue ?? 0;
      valor += this.venda.freightPrice ?? 0;
      return number.round(valor, 2);
    },
    valorPago() {
      if (!this.venda.paymentModeCollection) return 0;
      return this.venda.paymentModeCollection.reduce(
        (total, item) => total + this.getRangePayment(item.range),
        0,
      );
    },
  },
  watch: {
    client(value) {
      if (value.id) {
        this.getResellerMessage(value);
      }
    },
  },
};
</script>
